import React, { Component, PureComponent } from "react";
import { Grid, Row, Col } from "react-flexbox-grid";
import { connect } from "react-redux";
import { getUserProjects } from "../../redux/projects/actions";
import { getFilesByProjectIds, setFilter } from "../../redux/files/actions";
import * as authSelectors from "../../redux/auth/selectors";
import * as fileSelectors from "../../redux/files/selectors";
import * as projectSelectors from "../../redux/projects/selectors";
import ActivityIndicator from "react-activity-indicator";
import FilterPanel from "../../components/FilterPanel";
import DocumentsList from "../../components/DocumentsList";

import "./Files.css";

const mapStateToProps = state => ({
  userId: authSelectors.getUserId(state),
  projectsList: projectSelectors.projectsList(state),
  filesList: fileSelectors.filesList(state),
  isFetching: fileSelectors.filesIsFetching(state),
  filesSearchList: fileSelectors.fileSearchList(state),
  searchEnabled: fileSelectors.fileSearchEnabled(state),
  isSearchFetching: fileSelectors.fileSearchIsFetching(state),
  firebase: authSelectors.getFirebaseToken(state),
  timestamp: fileSelectors.timestamp(state),
  filter: fileSelectors.getFilter(state),

  filesIsFetched: fileSelectors.isFetched(state),
  projectsIsFetched: projectSelectors.projectIsFetched(state)
  // projectsList: state.project.list,
  // filesList: state.file.list
});

const mapDispatchToProps = {
  getUserProjects,
  getFilesByProjectIds,
  setFilter
  // getFilesByProject
};

class FilesScreen extends PureComponent {
  state = {
    filter: false,
    groups: {}
  };

  componentDidMount() {
    if (!this.componentHasData()) {
      this.componentUpdateData();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { projectsList, filesList } = nextProps;

    if (nextProps === this.props) {
      return;
    }

    if (!this.componentHasData()) {
      this.componentUpdateData(nextProps);
    }

    if (this.state.filter !== nextProps.filter) {
      this.setState({ filter: nextProps.filter });
    }
  }

  componentHasData() {
    const { projectsList, filesList, userId, firebase, filter } = this.props;
    return (
      Object.keys(projectsList).length > 0 && filesList && userId && firebase
    );
  }

  componentUpdateData(props = this.props) {
    const { projectsList, filesList, projectsIsFetched } = props;

    const projectIDs = Object.keys(projectsList);

    if (!projectIDs.length && props.userId && !projectsIsFetched) {
      this.props.getUserProjects(props.userId);
    }

    if (projectIDs.length && Object.keys(filesList).length === 0) {
      this.props.getFilesByProjectIds(projectIDs);
    }
  }

  _handleSetFilter = filter => {
    this.setState(
      {
        filter
      },
      () => {
        this.props.setFilter(filter);
      }
    );
  };

  _handleGroupsCollect = groups => {
    this.setState({
      groups
    });
  };

  render() {
    const { groups } = this.state;
    const { filter } = this.props;
    const {
      searchEnabled,
      filesSearchList,
      filesList,
      isSearchFetching,
      isFetching,
      timestamp
    } = this.props;

    return (
      <div className='dashboard-page-wrap'>
        <Grid fluid className="dashboard-page dashboard-page-small">
          <FilterPanel
            addTopMargin={false}
            filter={filter}
            onChange={this._handleSetFilter}
          />
          {(isSearchFetching && filesList !== false) ||
            (!filesList &&
              isFetching && (
                <Row center="xs" middle="xs" className="activity-wrapper">
                  <Col xs={12}>
                    <ActivityIndicator
                      number={5}
                      diameter={40}
                      duration={100}
                      activeColor="#5BA22F"
                      borderColor="white"
                      borderWidth={5}
                      borderRadius="50%"
                    />
                  </Col>
                </Row>
              ))}
          <DocumentsList
            filesList={filesList}
            searchEnabled={searchEnabled}
            filesSearchList={filesSearchList}
            timestamp={timestamp}
            filter={filter}
            onGroupsCollect={this._handleGroupsCollect}
          />
          {!isFetching &&
            filesList &&
            Object.keys(filesList).length === 0 && (
              <Row center="xs" middle="xs" className="activity-wrapper">
                <Col xs={12}>
                  <h2>Files list is empty</h2>
                </Col>
              </Row>
            )}
          {Object.keys(groups).length === 0 &&
            searchEnabled &&
            !isSearchFetching && (
              <Row center="xs" middle="xs" className="activity-wrapper">
                <Col xs={12}>
                  <h2>No results</h2>
                </Col>
              </Row>
            )}
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilesScreen);
